import { HideIcon, ShowIcon } from 'constants/icon.constants';
import React, { useCallback } from 'react';

import BaseAction from './BaseAction';
import { ENTITY_MASTER_NOTE_SECTION } from 'constants/schemas';
import PropTypes from 'prop-types';
import { entityActions } from 'store/entity';
import { useDispatch } from 'react-redux';
import { useMasterNoteSection } from 'hooks/store.hooks';

function MasterNoteSectionActionHideDescription(props) {
  const { id, ...restProps } = props;
  const dispatch = useDispatch();
  const hideDescription = useMasterNoteSection(id, 'hide_description');

  const onAction = useCallback(() => {
    dispatch(entityActions.update({
      type: ENTITY_MASTER_NOTE_SECTION,
      id,
      key: 'hide_description',
      value: !hideDescription,
    }));
  }, [id, dispatch, hideDescription]);

  return (
    <BaseAction
      icon={hideDescription ? <ShowIcon /> : <HideIcon />}
      label={hideDescription ? 'Show Description' : 'Hide Description'}
      onAction={onAction}
      {...restProps}
    />
  );
}

MasterNoteSectionActionHideDescription.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default MasterNoteSectionActionHideDescription;
